import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = _resolveComponent("router-view");
    const _component_el_config_provider = _resolveComponent("el-config-provider");
    return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: $options.locale,
        size: $data.config.size,
        zIndex: $data.config.zIndex,
        button: $data.config.button
    }, {
        default: _withCtx(()=>[
                _createVNode(_component_router_view)
            ]),
        _: 1
    }, 8, [
        "locale",
        "size",
        "zIndex",
        "button"
    ]);
}
